export default {
  title: 'Menuwijzigingsgeschiedenis',
  subtitle: 'Bekijk wie prijzen, beschikbaarheid en zichtbaarheid voor {{company}} heeft gewijzigd — en wanneer.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'Alle items',
    },
    event: {
      label: 'Gebeurtenis',
    },
  },
  columns: {
    when: 'Wanneer',
    who: 'Gewijzigd door',
    type: 'Type',
    item: 'Item',
    event: 'Gebeurtenis',
    changes: 'Wijzigingen',
  },
  types: {
    product: 'Product',
    modifier: 'Modifier',
  },
  events: {
    created: 'Aangemaakt',
    updated: 'Bijgewerkt',
    deleted: 'Verwijderd',
  },
  fields: {
    name: 'Naam',
    description: 'Beschrijving',
    price: 'Prijs',
    is_available: 'Beschikbaarheid',
    is_visible: 'Zichtbaarheid',
    is_available_for_pickup: 'Afhaal beschikbaarheid',
    is_available_for_delivery: 'Bezorg beschikbaarheid',
  },
  booleans: {
    on: 'Beschikbaar',
    off: 'Niet beschikbaar',
  },
  pagination: {
    previous: 'Vorige',
    next: 'Volgende',
  },
  causers: {
    orders_terminal: 'Bestellingsterminal',
  },
  system: 'Systeem',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Menuwijzigingsgeschiedenis laden mislukt',
  },
};
